import { Suspense, lazy } from 'react';
import type { SlotEntry } from '@saas/ui';

/**
 * 画面の差し込み口（`@saas/ui` の Slot）に invoice が出すもの。登録は apps/web/src/app/slots.ts（組み立て）だけが行う。
 *
 * | id | スロット | subjectType | order | 出すもの | context |
 * |---|---|---|---|---|---|
 * | invoice.project-billing | record.panel | project | 60 | 案件の請求額・入金額・未回収と最近の帳票（08 §3.4） | なし（subjectId） |
 *
 * 権限は「帳票を読める」（invoice.document.read.*）。中身は請求書側の閲覧範囲で絞り、案件が見えない・案件機能が無効・帳票が無いときは何も出さない。
 */
const ProjectInvoicesPanel = lazy(() => import('./components/ProjectInvoicesPanel.js'));

export const invoiceSlots: SlotEntry[] = [
  {
    id: 'invoice.project-billing',
    module: 'invoice',
    slot: 'record.panel',
    subjectTypes: ['project'],
    permission: ['invoice.document.read.own', 'invoice.document.read.team', 'invoice.document.read.all'],
    order: 60,
    Component: (props) => <Suspense fallback={null}><ProjectInvoicesPanel {...props} /></Suspense>,
  },
];
